<odx-modal-header>
  <odx-area-header>
    {{ headerText }}
  </odx-area-header>
</odx-modal-header>
<odx-modal-content>
  @if (!navigator.onLine) {
    <span i18n="@@fileModal.offline.warning"
      >Dies ist nur ein Vorschaubild. Bilder in Originalgröße können nur online geladen werden.</span
    >
  }
  <!-- prettier-ignore-attribute style -->
  <img [alt]="fileName" [src]="fileUrl$ | async" />
</odx-modal-content>
